import React, {ReactElement} from "react"
import {
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {DeleteOutline} from "@mui/icons-material";
import {Tooltip} from "../../../../App/components/Tooltip";
import {useAppDispatch} from "../../../../App/hooks/store";
import {ICode} from "../../interfaces/code";
import {CodeActions} from "../../actions/code";

interface Props {
  code: ICode
  onClose: (id: number) => void
}

export function Delete(props: Props): ReactElement | null {
  const dispatch = useAppDispatch();
  const { code, onClose } = props

  return (
    <Grid item>
      <Tooltip title="Удалить" placement="right">
        <IconButton
          edge="start"
          color="primary"
          onClick={(e) => {
            e.stopPropagation()
            dispatch(CodeActions.delete(code.id)).then(() => {
              onClose(code.id)
            })
          }}
        >
          <DeleteOutline />
        </IconButton>
      </Tooltip>
    </Grid>
  )
}
